<style>
  .row {
    margin-left: 0px;
    margin-right: 0px;
  }

  .panel-heading {
    padding: 5px;
  }

  .panel-body {
    background-color: #f2f6fa;
    padding: 20px;
  }

  #mapDiv {
    height: 700px;
  }

  #news {
    color: #4c637b;
  }

  #news a:hover {
    text-decoration: none;
  }
</style>

<!--    <link rel="stylesheet" href="/static/css/esri/css/esri_custom.css">-->

<!--    <link rel="stylesheet" href="/static/css/mapNavigation.css">-->

<div class="row" style="padding-top:30px; padding-bottom:30px">
  <div class="col-md-6">

    <div class="col-md-12" style="padding-bottom:10px;">
      <div class="panel panel-default">
        <div class="panel-heading" style="background-color: #0a79a9; color:#ffffff;">
          About
          <app-help-docs-links recordType="intro"></app-help-docs-links>
        </div>
        <div class="panel-body" style="padding:25px 25px 25px 25px; color:#4C637B; size: 14px">
          <div class="row"> WALTERS is a spatially linked electronic
            document storage system and your
            go-to
            product for data storage, access, management, and sharing.
            Use WALTERS to identify facilities, sites, or places of environmental interest
            in Guam. The improved storage
            design allows data to be attached to a geographic location for easy discovery and
            visualization, and the
            integrative system makes it easier than ever to share data between divisions.

            <br><br> By integrating WALTERS into your workflow, we can help make Guam a better place to
            live and work by sharing information to help obtain better environmental outcomes.

            <br><br> If you have feedback, questions, feature requests or discover an issue please email
            <a target="_blank" href="mailto:tbock@innovateteam.com">Travis Bock
              (tbock&#64;innovateteam.com)</a>
          </div>

        </div>
      </div>
    </div>

    <div class="col-md-12" style="padding-bottom:10px;">
      <div class="panel panel-default">
        <div class="panel-heading" style="background-color: #4f8e3e; color:#ffffff;">
          Counts
          <app-help-docs-links recordType="record"></app-help-docs-links>
        </div>
        <div class="panel-body" style="padding:25px 25px 25px 25px; color:#4C637B; size: 14px">
          <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-6" style="margin-bottom: 5px;">
              <h5 style="text-decoration: underline">Total Records</h5>
              <div class="row" *ngFor="let s of basicCounts">
                  <a style="padding-left: 0;" routerLink="/site/list" [queryParams]="{'dataset': s.dataset}">{{s.name}}: {{s.count}}</a>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6">

              <h5 style="text-decoration: underline">Solid Waste Permits</h5>
              <div class="row">
                Ongoing: {{ counts.Ongoing }}
              </div>
              <div class="row">
                Pending Docs: {{ counts.PendingDocs }}
              </div>
              <div class="row">
                Processing: {{ counts.Processing }}
              </div>
              <div class="row">
                RFS: {{ counts.RFS }}
              </div>
              <div class="row">
                Waiting: {{ counts.Waiting }}
              </div>

            </div>
            <div class="col-lg-4 col-md-6 col-sm-6">

              <h5 style="text-decoration: underline">Solid Waste Current Quarter</h5>
              <div *ngFor="let count of sw_currentquarter" class="row">
                {{ count.status }}: {{ count.total }}
              </div>

            </div>
            <div class="col-lg-4 col-md-6 col-sm-6">

              <h5 style="text-decoration: underline">Current Beach Advisories</h5>
              <div class="row">
                Closure: {{ beachCounts.current.CLOSURE || 0 }}
              </div>
              <div class="row">
                Contam Advisory: {{ beachCounts.current.CONTAM_ADV || 0}}
              </div>
              <div class="row">
                Permanent Closure: {{ beachCounts.current.PERM_CLOSURE || 0 }}
              </div>
              <div class="row">
                Posting: {{ beachCounts.current.POSTING || 0 }}
              </div>
              <div class="row">
                Rain Advisory: {{ beachCounts.current.RAIN_ADV || 0 }}
              </div>
              <div class="row">
                Total: {{ beachCounts.current.total || 0 }}
              </div>

            </div>
            <div class="col-lg-4 col-md-6 col-sm-6">

              <h5 style="text-decoration: underline">Last 30 Days Beach Advisories</h5>
              <div class="row" *ngFor="let type of advisory_type_codes">
                {{type.display_name}}: {{ beachCounts.last30days[type.value] || 0 }}
              </div>
              <div class="row">
                Total: {{ beachCounts.last30days.total || 0 }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--            <div class="col-md-12" id="news" style="padding-bottom:10px;">-->
    <!--                <div class="panel panel-default">-->
    <!--                    <div class="panel-heading" style="background-color: #65b14e; color:#ffffff;">-->
    <!--                        News -->
    <!--                        <help-docs-link record-type="news"></help-docs-link>-->
    <!--                    </div>-->
    <!--                    <div class="panel-body" style="padding:20px 10px;">-->
    <!--                        <div class="row" style="padding-bottom: 20px;">-->
    <!--                            News will be back soon.-->
    <!--                            &lt;!&ndash;<i class="fa fa-twitter fa-2x pull-left"></i>&ndash;&gt;-->
    <!--                            &lt;!&ndash;<div class="col-sm-11">&ndash;&gt;-->
    <!--                            &lt;!&ndash;<p>Guam EPA Twitter | @GuamEPA</p>&ndash;&gt;-->
    <!--                            &lt;!&ndash;<feed summary="true"&ndash;&gt;-->
    <!--                            &lt;!&ndash;url="https://twitrss.me/twitter_user_to_rss/?user=guamepa"&ndash;&gt;-->
    <!--                            &lt;!&ndash;count="5"&ndash;&gt;-->
    <!--                            &lt;!&ndash;template-url="/static/custom-feed-list.html"/>&ndash;&gt;-->
    <!--                            &lt;!&ndash;</div>&ndash;&gt;-->
    <!--                        </div>-->
    <!--                        &lt;!&ndash;<div class="row" style="padding-bottom: 20px;">&ndash;&gt;-->
    <!--                        &lt;!&ndash;<i class="fa fa-rss fa-2x pull-left"></i>&ndash;&gt;-->
    <!--                        &lt;!&ndash;<div class="col-sm-11">&ndash;&gt;-->
    <!--                        &lt;!&ndash;<p>EPA Region 9</p>&ndash;&gt;-->
    <!--                        &lt;!&ndash;<feed summary="true"&ndash;&gt;-->
    <!--                        &lt;!&ndash;url="https://www.epa.gov/newsreleases/search/rss/field_press_office/region-09"&ndash;&gt;-->
    <!--                        &lt;!&ndash;count="5"&ndash;&gt;-->
    <!--                        &lt;!&ndash;template-url="/static/custom-feed-list.html"/>&ndash;&gt;-->
    <!--                        &lt;!&ndash;</div>&ndash;&gt;-->
    <!--                        &lt;!&ndash;</div>&ndash;&gt;-->
    <!--                        &lt;!&ndash;<div class="row" style="padding-bottom: 20px;">&ndash;&gt;-->
    <!--                        &lt;!&ndash;<i class="fa fa-bolt fa-2x pull-left"></i>&ndash;&gt;-->
    <!--                        &lt;!&ndash;<div class="col-sm-11">&ndash;&gt;-->
    <!--                        &lt;!&ndash;<p>National Weather Service Alerts for Guam</p>&ndash;&gt;-->
    <!--                        &lt;!&ndash;<feed summary="true"&ndash;&gt;-->
    <!--                        &lt;!&ndash;url="https://alerts.weather.gov/cap/wwaatmget.php?x=GUZ001&y=0"&ndash;&gt;-->
    <!--                        &lt;!&ndash;count="5"&ndash;&gt;-->
    <!--                        &lt;!&ndash;template-url="/static/custom-feed-list.html"/>&ndash;&gt;-->
    <!--                        &lt;!&ndash;</div>&ndash;&gt;-->
    <!--                        &lt;!&ndash;</div>&ndash;&gt;-->
    <!--                    </div>-->
    <!--                </div>-->
    <!--            </div>-->

  </div>
  <!-- /.col-lg-12 -->


  <div class="col-md-6">
    <div class="col-md-12" style="padding-bottom:10px;"
         *ngIf="show_messages">
      <div class="panel panel-default">
        <div class="panel-heading" style="background-color:#d9534f; color:#ffffff;">
          You have important messages!
        </div>
        <div class="panel-body">
          <div *ngIf="total_permits > 0">
            You have {{ total_permits }} {{ total_permits > 1 ? 'permits' : 'permit' }} ready for your review. Go to
            your <a routerLink="/permit/review" [queryParams]="{current_user: true,
                      is_next: true,
                      all_permits:false,
                      current_status: 'needed',
                      ordering: '-submission_date'}">Permit Review Queue</a> to begin.
          </div>
          <div *ngIf="applications_to_review > 0">
            You have {{ applications_to_review }} Standby
            Generator {{ applications_to_review > 1 ? 'applications' : 'application' }} ready for your review. Go to
            your <a routerLink="/applications/standby">Application Review Queue</a> to
            begin.
          </div>
          <div *ngIf="permits_issued > 0">
            You have {{ permits_issued }} Standby Generator {{ permits_issued > 1 ? 'permits' : 'permit' }} ready for
            notification. Go to your <a routerLink="/permits/notification/standby">Permit Notification Queue</a> to begin.
          </div>
          <div *ngIf="ust_actions_past_due > 0">
            You have {{ ust_actions_past_due }} past due <a
            routerLink="/site/list" [queryParams]="{dataset: 'ust', ust_past_due_actions: 'true'}">Storage
            Tank {{ ust_actions_past_due > 1 ? 'enforcement actions' : 'enforcement action' }}</a>.
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12" style="padding-bottom:10px;">
      <div class="panel panel-default">
        <div class="panel-heading" style="background-color:#f7bc66; color:#ffffff;">
          Search
          <app-help-docs-links recordType="search"></app-help-docs-links>
        </div>
        <div class="panel-body">
          <div class="input-group custom-search-form">
            <input (keyup.enter)="searchSites(searchText)"
                   [(ngModel)]="searchText" type="text"
                   class="form-control has-feedback has-clear" id="search"
                   style="font-family: Helvetica, FontAwesome" placeholder="&#xF002; Search...">
            <span class="input-group-btn">
                            <button type="button" class="btn btn-primary" style="height:34px;"
                                   (click)="searchSites(searchText)">
                                <i class="fa fa-search"></i>
                            </button>
                            </span>
          </div>
        </div>
      </div>
    </div>

    <app-dashboard-map></app-dashboard-map>
    <!-- /.container-fluid -->
  </div>
</div>

<!-- /#page-wrapper -->
